<div id="content" class="allcp-form" ng-class="{'mt-2' : collapseMenuStatus}" ng-controller="CustomerHistoryController">
    <div ng-if="!collapseMenuStatus" ng-include="'modules/customer/partials/top_menu.html'"></div>
    <div ng-if="!collapseMenuStatus" ng-include="'modules/customer/partials/order_filter_menu.html'"></div>
    <div class="panel-body">
        <div class="alert alert-white" role="alert" ng-if="data.not_delivery_zone">
            <div class="row p10">
                <div class="col-md-8">
                    <p>Attention! The following zipcodes are out of our delivery zone.</p>
                    <p>Zipcodes : <strong>{{ data.not_delivery_zone.join() }} </strong></p>
                </div>
                <div class="col-md-4 text-right">
                    <a href="#" class="btn btn-operation" ng-click="removeNotDelivery()">
                        Understand
                    </a>
                </div>
            </div>
        </div>
        <div ng-include="'modules/customer/partials/live_orders.html'"></div>
    </div>
    <div class="navbar fixed-panel-footer" ng-if="selectedItems.length">
        <div class="nav navbar-nav navbar-left">
            <a href="#" ng-click="selectAllOrder(true)" class="btn mr-2 btn-outline">Select All</a>
            <a href="#" ng-click="selectAllOrder(false)" class="btn btn-outline">Unselect</a>
        </div>
        <div class="nav navbar-nav navbar-center">
        </div>
        <div class="nav navbar-nav navbar-right">
            <a href="#"
               data-toggle="modal"
               data-target="#deleteOrdersModal"
               class="btn btn-danger btn-rounded mr-3">Delete</a>
            <!-- <a href="/print-order/{{ selectedItems }}"
               target="__BLANK"
               class="btn btn-outline">Print {{ selectedItems.length }} Label</a> -->
            <a href="#"
               ng-click="printDeliveryOrder(selectedItems)"
               class="btn btn-outline">Print {{ selectedItems.length }} Label(s)</a>
            <a href="#"
               ng-click="changeStatusMulti('prepared', selectedItems)"
               class="btn btn-outline ml-2">Prepared {{ selectedItems.length }} Order(s)</a>
        </div>
    </div>
    <!-- Delete Orders -->
    <div class="modal info-box fade" id="deleteOrdersModal" tabindex="-1" role="dialog" aria-labelledby="deleteOrdersModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content p25">
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <p class="pb25">Are you sure you want to delete {{ selectedItems.length == 1 ? 'this' : selectedItems.length }} order{{ selectedItems.length > 1 ? 's' : '' }}?</p>
                            <!-- <strong>Devam etmek istiyor musunuz ?</strong> -->
                            <!-- <div class="checkbox-custom fill checkbox-success mt10">
                                <input type="checkbox" id="sms" ng-model="send_cancel_sms" ng-true-value="1"
                                       ng-false-value="0" name="tracking_sms">
                                <label for="sms" class="fs11">
                                    <a href="#" class="hint--medium hint--top pull-left" style="font-size: 14px;"
                                       aria-label="Bu seçeneği işaretlerseniz kargolar silindiği zaman, müşterilere kargo iptal edildi sms'i gönderilecektir.">
                                        <i class="fa fa-question-circle"></i>
                                        İptal Mesajı Gönderilsin
                                    </a>
                                </label>
                            </div> -->
                        </div>
                    </div>

                    <div class="">
                        <button type="submit" class="btn pull-right btn-danger" ng-click="deleteOrders(send_cancel_sms)">
                            Delete
                        </button>
                        <button type="button" class="btn pull-left btn-default" data-dismiss="modal" data-toggle="modal">Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Report Orders -->
    <div class="modal right fade" id="reportModal" tabindex="-1" role="dialog" aria-labelledby="reportModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title">
                        <h4 id="reportModalLabel">Reports</h4>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <i class="icon-close-circle"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="modal-body-container">
                        <div class="row mt-2">
                            <div class="col-md-3">
                                <div class="panel panel-tile border-chart text-center">
                                    <div class="m-4">
                                        <h3 class="mbn mtn text-dark">{{ data.count.total?data.count.total:0 }} </h3>
                                        <strong>Total Orders</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="panel panel-tile border-chart text-center">
                                    <div class="m-4">
                                        <h3 class="mbn mtn text-dark">{{ data.count.other?data.count.other:0 }} </h3>
                                        <strong>Pending Orders</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="panel panel-tile border-chart text-center">
                                    <div class="m-4">
                                        <h3 class="mbn mtn text-dark">{{ data.count.fail?data.count.fail:0 }} </h3>
                                        <strong>Unsuccessful Orders</strong>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="panel panel-tile border-chart text-center">
                                    <div class="m-4">
                                        <h3 class="mbn mtn text-dark">{{ data.count.success?data.count.success:0
                                            }} </h3>
                                        <strong>Completed Orders</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- <hr>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="progress">
                                <div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="{{ (100 - ((100 * data.count.fail) / data.count.total)).toFixed(2) }}" aria-valuemin="0" aria-valuemax="100" ng-style="{ width: (100 - ((100 * data.count.fail) / data.count.total)).toFixed(2) + '%'}">
                                    {{ (100 - ((100 * data.count.fail) / data.count.total)).toFixed(2) }}% Success Rate
                                </div>
                            </div>
                        </div>
                    </div> -->
                        <div class="row mt-4">
                            <div class="col-md-12">
                                <canvas id="line" class="chart chart-line" chart-data="barChartData"
                                        chart-labels="data.chart.labels" chart-series="series"
                                        chart-colours="chartColors" chart-legend="true">
                                </canvas>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-md-9">
                                <canvas id="doughnut" class="chart chart-doughnut" ng-if="chartData"
                                        chart-data="chartData" chart-labels="series" chart-colours="chartColors"
                                        chart-legend="true">
                                </canvas>
                            </div>
                            <!-- <div class="col-md-3 align-items-end justify-content-end d-flex">
                                <a href="/print-order/x" target="__BLANK" class="btn">
                                    Print
                                </a>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div ng-include="'modules/customer/partials/update_order.html'"></div>
</div>
</div>
